import Role from "../../lib/Role";

/**
 * @return {boolean}
 */
function CanCreateGroup(loggedInUser) {
    return loggedInUser.role === Role.ADMIN;
}
export default CanCreateGroup;